<template>
  <transition name="modal-fade">
    <div
      class="modal"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <div
        class="modal__backdrop"
        @click="close"
      />
      
      <div class="modal__inner">
        <!-- <module-logo /> -->
        <h3 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="c-accent mt">{{ modal.title }}</h3>
        <p v-if="modal.copy" class="p small" v-html="modal.copy" />
        <slot name="modal-body" />
        <slot name="modal-footer" />
      </div>
    </div>
  </transition>
</template>

<script>

// Vuex
import { mapGetters } from 'vuex';


export default {
  name: 'module-modal',

  props: {
    modal: Object,
  },


  computed: {
    ...mapGetters('app', ['org']),
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },


  mounted() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// Modal.vue?641c3348